<script>
import Address
  from '@nextories/vue-core-components/src/components/molecules/address/NxtCoreAddress.vue';
import AutoCompleteAddress from '../../molecules/address/AutoCompleteAddress.vue';
import getFlagBaseUrl from '../../../utils/flagBaseUrl';

export default {
  extends: Address,
  name: 'Address',
  components: {
    AutoCompleteAddress,
  },
  props: {
    flagBaseUrl: {
      type: String,
      default: getFlagBaseUrl,
    },
  },
};
</script>
